import { render, staticRenderFns } from "./ServerUserList.vue?vue&type=template&id=b08e4010&"
import script from "./ServerUserList.vue?vue&type=script&lang=js&"
export * from "./ServerUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports